import { Skeleton } from '@parrot-software/design-system';

/**
 * Loading skeleton for the invoice data card grid.
 * Renders 3 skeleton cards matching the InvoiceDataCard layout.
 */
export const InvoiceDataListSkeleton = () => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    {Array.from({ length: 3 }).map((_, i) => (
      <div className="flex flex-col gap-4 rounded-xl border p-5 shadow-xs" key={`skeleton-${i}`}>
        <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 pr-8">
          {Array.from({ length: 6 }).map((__, j) => (
            <div className="contents" key={`field-${j}`}>
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-32" />
            </div>
          ))}
        </div>
        <Skeleton className="h-9 w-full rounded-md" />
      </div>
    ))}
  </div>
);
